import axios from "axios";
import { parseCookies } from "nookies";
import { logout } from "./auth";

export function getAPIClient() {
  const { token } = parseCookies();

  const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_API,
    withCredentials: false,
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  });

  api.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  // Add a response interceptor
  api.interceptors.response.use(
    function (response) {
      // Do something with response data
      return response;
    },
    function (error) {
      // sessão revogada/expirada (usuário ou operadora desativada) — derruba e volta pro login
      const status = error?.response?.status;

      if ((status === 401 || status === 403) && window.location.pathname !== "/login") {
        logout();
      }

      return Promise.reject(error);
    }
  );

  if (token) {
    api.defaults.headers["Authorization"] = `Bearer ${token}`;
  }

  api.getToken = () => {
    return parseCookies()?.token || null;
  };

  return api;
}
